<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <RouterView />
    <Toaster />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toaster from '@/components/ui/Toaster.vue'
</script>

<style>
:root { color-scheme: dark; }

body { margin: 0; }
</style>

<style scoped>
#app {
  font-family: 'Inter', system-ui, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>